var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-3 pb-3"},[_c('v-btn',{attrs:{"block":"","color":"black"},on:{"click":function($event){return _vm.userManager.logout()}}},[_vm._v("Logout")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }